import { Component, input, TemplateRef, ViewChild, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'iot-platform-ui-tab-header',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <ng-template>
      {{ textLabel() }}
      <ng-content />
    </ng-template>
  `
})
export class TabHeaderComponent {
  textLabel = input<string>('');
  tooltip = input<string>('');
  cssClassName = input<string>('');
  visible = input<boolean>(true);

  @ViewChild(TemplateRef) public template!: TemplateRef<any>;
}
